import styles from './OnboardingProgress.module.scss';
import cn from 'classnames';
import { Container } from "../../components/Container/Container";

export const OnboardingProgress = ({ currentData, totalData }) => {
  const title = currentData.headerStatus;
  if (!title) return null;
  const steps = totalData.reduce((acc, item) => {
    if (item.headerStatus && !acc.some(s => s.title === item.headerStatus)) {
      // В этой группе все элементы с таким же headerStatus
      const groupItems = totalData.filter(i => i.headerStatus === item.headerStatus);
      acc.push({
        title: item.headerStatus,
        slugs: groupItems.map(i => i.slug),
      });
    }
    return acc;
  }, []);

  const currentStepIdx = steps.findIndex(s => s.title === title);

  // 3. Внутри текущего шага: узнать позицию экрана
  const currentStep = steps[currentStepIdx];
  const currentScreenIdx = currentStep.slugs.indexOf(currentData.slug);

  // 4. Прогресс внутри текущего блока (от 0 до 1)
  const innerProgress = (currentScreenIdx + 1) / currentStep.slugs.length;

  const stepCount = steps.length;
  const getDotPosition = idx => (stepCount === 1 ? 0 : (idx / (stepCount - 1)) * 100);
  // Позиция текущего кружка:
  const activeDotPosition =
    currentStepIdx < 0
      ? 0
      : getDotPosition(currentStepIdx) +
        ((getDotPosition(currentStepIdx + 1) - getDotPosition(currentStepIdx)) *
          innerProgress || 0);
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{title}</div>
      <Container className={styles.progressBar}>
        <div className={styles.progressLine}>
          <div
            className={styles.progressFill}
            style={{
              left: '0%',
              width: `${activeDotPosition}%`,
            }}
          />
        </div>
        {steps.map((step, idx) => (
          <div
            key={step.title}
            className={cn(styles.step, {
              [styles.completed]: idx < currentStepIdx,
              [styles.active]: idx === currentStepIdx,
            })}
          >
            <div className={styles.dot} >
              <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M0.219175 0.606757C0.173024 0.563315 0.170468 0.47356 0.23586 0.40409C0.301252 0.334619 0.390999 0.331746 0.415352 0.398344C2.28709 1.4614 4.57561 1.38814 6.38345 0.207313C6.45012 0.182721 6.53986 0.179848 6.58601 0.223289C6.63217 0.266731 6.63472 0.356487 6.6142 0.42452C5.54478 2.30041 5.60996 4.58918 6.78418 6.39325C6.83033 6.4367 6.83289 6.52645 6.76749 6.59592C6.7239 6.64223 6.63415 6.64511 6.5662 6.62482C4.71626 5.53861 2.40595 5.63502 0.619908 6.79269C0.576313 6.83901 0.463491 6.82016 0.41734 6.77672C0.371189 6.73328 0.368634 6.64352 0.389153 6.57549C1.45858 4.69959 1.3934 2.41083 0.219175 0.606757Z" fill="white" />
              </svg>
            </div>

          </div>
        ))}
      </Container>
    </div>
  );
};
